import SidePanel from './sidepanel';

const LinkToRemove = {
  start() {
    SidePanel.onUpdate(($sidepanel) => {
      $sidepanel.find('[data-remove]').on('ajax:success', this.removeTarget);
    });
  },

  removeTarget(e) {
    // Read X-Reload-Parent-On-Close before detaching the link from the DOM.
    // sidepanel.js has a delegated ajax:success handler that does the same,
    // but jQuery may skip the bubbled handler when the link's parent has
    // already been removed by the line below.
    const xhr = e.detail && e.detail[2];
    if (xhr && xhr.getResponseHeader('X-Reload-Parent-On-Close')) {
      SidePanel._reloadParentOnClose = true;
    }
    const $target = $(e.currentTarget.dataset.remove);
    $target.remove();
  }
};

export default LinkToRemove;
